import React from 'react'
import { Helmet } from 'react-helmet';
import ContactForm from '../../Components/Contact/ContactForm'
import SectionContact from '../../Components/Contact/SectionContact'
import Worktogether from '../../Components/Home/worktogether'

const Contact = () => {
  return (
    <div>
      <Helmet>
        <title>Get in Touch | Explore Real Estate Investment Opportunities</title>
        <meta name="description" content="Connect with us to discover profitable real estate investment opportunities. Get expert insights on high-ROI residential, commercial, and luxury properties" />
        <meta property="og:url" content="https://www.coownspace.com/contact" />

      </Helmet>
      <ContactForm />
      <SectionContact />
      <Worktogether />
    </div>
  )
}

export default Contact;
